import AbstractScene from './AbstractScene.js';
import { Colors } from '../consts/Colors.js';

export default class Activite3Video extends AbstractScene {
    constructor() {
        super({
            key: "Activite3Video"
        })
    }
    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();
        this.videoKey = 'videoChaineAlimentaire';
        this.preTarget = () => this.scene.start('Activite3')
        this.postTarget = () => this.scene.start('Activite4')
        this.allControls = []
    }


    update() {
        if (this.isPlaying && !this.isDraging) {
            this.currentTiming = this.video.getCurrentTime()
            this.totalDuration = this.video.getDuration()
            this.slider.value = this.currentTiming / this.totalDuration
            const progress = this.video.getProgress();
            this.barFill.width = progress * 1527;
        } else if (this.isDraging) {
            const progress = this.video.getProgress();
            const duration = this.video.getDuration();
            const current = progress * duration;
            this.currentTimeText.setText(this.formatTime(current));
            this.barFill.width = this.slider.value * 1527;
        }
        if (this.isPlaying) {
            const duration = this.video.getDuration();
            const progress = this.video.getProgress();
            const current = progress * duration;
            this.currentTimeText.setText(this.formatTime(current));
            this.durationText.setText(this.formatTime(duration));
        }
    }


    create() {
        this.isDraging = false
        this.isPlaying = false
        const blocker = this.add.rectangle(this.width / 2, this.height / 2, this.width, this.height, Colors.Elmt.Black)

        // 📹 1. Ajoute la vidéo
        this.video = this.add.video(0, 0, 'videoChaineAlimentaire').setOrigin(0.5).setDepth(1);

        // 2. On centre la vidéo au milieu du canvas
        this.video.setPosition(this.width / 2, this.height / 2);

        // ▶️ 3. Bouton Play au centre
        this.isPaused = false;
        const startButton = this.add
            .image(this.width / 2, this.height / 2, 'videoPlay')
            .setOrigin(0.5)
            .setInteractive({ useHandCursor: true })
            .setDepth(3);
        startButton.setAlpha(1);

        // Boutons avancer/reculer (non visibles au départ)
        const buttonReculer = this.add
            .image(100, this.height - 100, 'videoBack')
            .setOrigin(0.5)
            .setInteractive({ useHandCursor: true })
            .on('pointerdown', () => {
                this.scene.start('Activite3');
            })
            .setVisible(false)
            .setDepth(20);

        const buttonAvancer = this.add
            .image(this.width - 100, this.height - 100, 'videoNext')
            .setOrigin(0.5)
            .setInteractive({ useHandCursor: true })
            .on('pointerdown', () => {
                this.scene.start('Activite4');
            })
            .setVisible(false)
            .setDepth(20);

        // 🕹️ Animation au survol du bouton Play
        startButton.on('pointerover', () => {
            this.tweens.add({
                targets: startButton,
                scale: 1.1,
                duration: 200,
                ease: 'Sine.easeInOut',
            });
        });

        startButton.on('pointerout', () => {
            this.tweens.add({
                targets: startButton,
                scale: 1,
                duration: 200,
                ease: 'Sine.easeInOut',
            });
        });

        // Clique sur le bouton Play pour démarrer la vidéo
        startButton.on('pointerdown', () => {
            this.video.play();
            this.isPlaying = true;
            this.video.setMute(false);
            this.video.setVolume(1); // au cas où
            this.isPaused = false;
            startButton.setAlpha(0); // Cache le bouton play
            buttonAvancer.setVisible(true);
            buttonReculer.setVisible(true);
            // controlsGroup.setVisible(false);
            startButton.disableInteractive();
        });

        // ⏱️ Texte durée
        this.currentTimeText = this.add
            .text(1560, this.height - 150, '0:00', {
                fontSize: "20px",
                color: '#fff',
                fontFamily: 'Monteserrat',
            })
            .setOrigin(0.5).setDepth(20)

        const barretime = this.add
            .text(1590, this.height - 150, '/', {
                fontSize: "20px",
                color: '#fff',
                fontFamily: 'Monteserrat',
            })
            .setOrigin(0.5).setDepth(20)
        // let duration = this.video.getDuration();
        this.durationText = this.add
            .text(1620, this.height - 150, "0:00", {
                fontSize: "20px",
                color: '#fff',
                fontFamily: 'Monteserrat',
            })
            .setOrigin(0.5).setDepth(20)

        // 🧱 Groupe pour les contrôles bas
        // const controlsGroup = this.add.container(0, 0, [
        //     barBg,
        //     barFill,
        //     currentTimeText,
        //     barretime,
        //     durationText,
        // ]);
        // controlsGroup.setDepth(5).setVisible(false);

        // // 📈 Mise à jour de la barre de progression
        // this.time.addEvent({
        //     delay: 200,
        //     loop: true,
        //     callback: () => {
        //         if (video.isPlaying()) {
        //             const progress = video.getProgress();
        //             const duration = video.getDuration();
        //             console.log(`Progress: ${progress}, Duration: ${duration}`);
        //             const current = progress * duration;
        //             barFill.width = progress * 1527;

        //             currentTimeText.setText(this.formatTime(current));
        //             durationText.setText(this.formatTime(duration));
        //         }
        //     },
        // });

        // const barBg = this.add
        //     .rexRoundRectangle(200, this.height - 100, 1527, 6, 3, Colors.Elmt.White)
        //     .setOrigin(0, 0.5)
        //     .setAlpha(0.5);

        this.sliderLine = this.add.rexRoundRectangle(this.width / 2, this.height - 100, 1528, 6, 3, Colors.Elmt.White).setAlpha(0.5).setDepth(20);
        this.barFill = this.add.rexRoundRectangle(this.width / 2 - 764, this.height - 100, 0, 6, 3, Colors.Elmt.White).setOrigin(0, 0.5).setDepth(20);
        this.sliderLine.setSize(1528, this.sliderLine.height)
        this.sliderLine.setInteractive({ useHandCursor: true });
        this.sliderLine.on('pointerdown', (event) => {
            let a = event.x
            let b = this.sliderLine.x
            let c = a - b
            let value = (c + 764) / 1528
            this.barFill.width = value * 1528
            this.slider.value = value
            this.video.seekTo(value);
        })
        this.sliderButton = this.add.circle(this.width / 2 - 764, this.height - 100, 15, Colors.Elmt.White).setInteractive({ useHandCursor: true }).setAlpha(1).setDepth(20);
        this.sliderButton.setStrokeStyle(4, Colors.Elmt.White)
        this.sliderButton.on('pointerdown', () => {
            this.isDraging = true
            this.isPlaying = false
            this.video.setPaused(true)
        })
        this.sliderButton.on('pointerup', () => {
            this.isDraging = false
            if (this.isPaused) {
                this.isPlaying = false
                this.video.setPaused(true)
            } else {
                this.isPlaying = true
                this.video.setPaused(false)
            }
        })

        this.input.on('pointerup', () => {
            if (this.isDraging) {
                this.isDraging = false
                this.isPlaying = true
                this.video.setPaused(false)
            }
        })

        this.slider = this.plugins.get('rexSlider').add(this.sliderButton, {
            endPoints: [
                { x: this.sliderLine.x - 764, y: this.sliderLine.y },
                { x: this.sliderLine.x + 764, y: this.sliderLine.y }
            ],
            value: 0,
            enable: true,
            valuechangeCallback: (value) => {
                if (this.isDraging) {
                    // console.log("Slider value", value);
                    this.video.seekTo(value);
                }
            }
        });

        // 📥 Sur fin de la vidéo
        let hasEnded = false;

        this.video.on('complete', () => {
            console.log('Video playback completed');
            this.scene.start('Activite4');
            hasEnded = true;
        });

        // Clique sur la vidéo pour la mettre en pause ou reprendre
        this.video.setInteractive();
        this.video.on('pointerdown', () => {
            if (hasEnded) return;

            // Si la vidéo est en pause, la reprendre
            if (this.isPaused) {
                console.log('reprise de la vidéo');
                this.video.resume();
                startButton.setAlpha(0); // Cacher le bouton Play
                this.isPaused = false;
                this.isPlaying = true
            } else {
                console.log('mettre en pause la vidéo');
                // Sinon, mettre la vidéo en pause
                this.video.pause();
                startButton.setAlpha(1); // Montrer le bouton Play
                this.isPlaying = false
                this.isPaused = true;
            }

            // // Permettre ou désactiver les interactions en fonction de l'état de la vidéo
            // video.setInteractive(!this.isPaused);
        });

    }

    formatTime(seconds) {
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    }
}